import React, { FunctionComponent, useCallback } from 'react'
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { createPortal } from 'react-dom'
import { setShowTrainingModeModal } from '../state/slices/uiStateSlice'
import { RootState } from '../state/store'
import { useTrainingModeManager } from '../ng-compat/hooks'

const selectShowModal = createSelector(
  (state: RootState) => state.uiState.showTrainingModeModal,
  (showTrainingModeModal: boolean) => showTrainingModeModal
)

export const TrainingModeModal: FunctionComponent = () => {
  const showModal = useSelector(selectShowModal)
  const dispatch = useDispatch()
  const trainingModeManager = useTrainingModeManager()

  const closeModal = useCallback(() => {
    dispatch(setShowTrainingModeModal(false))
  }, [dispatch])

  if (!showModal || !trainingModeManager.trainingModeEnabled) {
    return null
  }

  return createPortal(
    <Modal onClose={closeModal}>
      <ModalHeader>
        <T _str="You’re now in training mode" />
      </ModalHeader>
      <ModalContent>
        <T _str="Sales and payments you make in training mode will not be recorded. Feel free to try out all the features." />
      </ModalContent>
      <ModalActions>
        <Button onClick={closeModal} variant="go">
          <T _str="Got it" context="Button to close training mode modal" />
        </Button>
      </ModalActions>
    </Modal>,
    document.body
  )
}
